<template>
    <div class="billing_current_view">
        <loading v-if="loading"/>
        <!-- 停車帳務_view -->
            <section class="chapternav-top">
              <div class="container">
                <div class="row">
                  <div class="col-lg-12 text-center">
                    <h2 class="section-heading text-uppercase">Billing</h2>
                    <h3 class="section-subheading text-muted">停車帳務</h3>
                  </div>
                </div>
               <div class="row">
                  <div class="col-lg-6 billing-view-box row" v-if="billing.id">

                    <div class="col-lg-12 billing-current-card">
                        <div class="billing-current-title">停車中</div>
                        <div class="billing-top-box">
                            <div class="billing-time-box">
                                <div class="billing-time">
                                  {{ billing.counted_at | DateToDay }} <br/>
                                  <span>{{ billing.counted_at | DateToTime }}</span>
                                </div>
                                <div class="billing-arrow">
                                  >
                                </div>
                                <div class="billing-time">
                                 {{ currentTime | DateToDay }}  <br/>
                                  <span> {{ currentTime | DateToTime }}</span>
                                </div>
                                <div style="clear: both;"></div>
                            </div>
                            <div class="billing-price-box">
                              <div class="billing-price-number2">已累計金額</div>
                              <div class="cb"></div>
                              <div class="billing-price-number" v-if="billing.price">{{ billing.price.result }}</div>
                              <div class="cb"></div>
                            </div>
                            <div style="clear: both;"></div>
                        </div><!--billing-top-box ends-->
                        <div class="billing-place-box">
                          <div class="billing-plate">{{ billing.plate }}</div>
                          <router-link :to="'parkinglot_view?id=' + billing.lot.id" v-if="billing.lot" class="billing-place">{{ billing.lot.name }}</router-link>
                          <div style="clear: both;"></div>
                        </div>
                    </div><!--billing-card ends-->
                    
                  </div><!--billing-view-box ends-->
                  
                </div><!--row ends-->
                
                <div class="row" v-if="billing.id">
                  
                  <div class="col-lg-8 center text-center"  v-if="billing.price.result">
                    <button v-on:click="paid_button_click" class="btn btn-pay btn-xl" >繳停車費</button>
                  </div>

                  <div class="col-lg-8 center">
                      <!--
                      <div class="btn-services fl">
                        <a class="btn btn-frame js-scroll-trigger" href="#">聯絡客服</a>
                      </div>
                      !-->
                      <div class="btn-back fr">
                        <button class="btn btn-primary js-scroll-trigger" @click="$router.go(-1)"><i class="fas fa-chevron-left"></i> BACK</button>
                      </div>
                      <div class="cb"></div>
                  </div>
                </div><!--row ends-->


                  
              </div><!--container ends-->
            </section>

    </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'BillingCurrentView',
  props: {
  },
  filters: {
    DateToDay(value) {
      return moment(String(value)).format('YYYY.MM.DD')
    },
    DateToTime(value) {
      return moment(String(value)).format('HH:mm')
    }
  },
  data() {
    return {
      billing: {},
      loading: true,
      currentTime: ""
    }
  },
  mounted() {
    var self = this
    self.getbillingDetails()
    self.currentTime = moment().format("YYYY-MM-DD HH:mm")
  },
  methods: {
    getbillingDetails: function() {
      var self = this
      if (parseInt(self.$route.query.id) > 0) {
        self.$http.get('https://' + process.env.VUE_APP_API_URL + '/parking_records/details?access_token=' + self.$cookie.get('access_token') + '&id=' + self.$route.query.id)
          .then(response => response.json())
          .then(json => {
            self.billing = json
            self.loading = false
          })
          .catch((response) => {
            console.log("取得資料失敗")
            self.$router.push({ name: 'member_center' })
          })
          .finally(() => {
          });
      } else {
        self.loading = false
      }
    },
    paid_button_click: function() {
      var self = this
      window.location.replace("https://" + process.env.VUE_APP_API_URL + "/payment/line?plate=" + self.billing.plate + "&parking_record_id=" + self.billing.id + "&access_token=" + self.$cookie.get('access_token') + "&brand=" + process.env.VUE_APP_BRAND);
    }
  }
}
</script>